var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0974 52.0215H29.877",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4383 5.7153V2",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8716 13.7849L42.8847 10.7637",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.7637L5.01307 13.7849",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4873 47.1068V32.9805",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4791 32.9804L27.4682 27.9668",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4056 32.9804L17.4164 27.9668",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4791 11.235C18.18 11.1979 14.0416 12.8667 10.9712 15.8759C7.90069 18.8852 6.14863 22.9887 6.09907 27.2877C5.98058 30.6124 7.0292 33.8739 9.06316 36.5066C9.74906 37.2496 10.4513 37.9031 11.1209 38.54C13.4072 40.6957 15.5793 42.7617 16.2325 47.1058H28.7175C29.3789 42.7291 31.551 40.6877 33.8455 38.532C34.5232 37.8951 35.2173 37.2415 35.8705 36.5393C37.969 34.0896 38.8672 31.2969 38.8672 27.2877C38.8155 22.988 37.0617 18.8841 33.9899 15.8751C30.9181 12.8661 26.779 11.1979 22.4791 11.235Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9102 56.5625H19.0822C19.4396 57.1434 19.9398 57.6228 20.5351 57.9556C21.1305 58.2883 21.8011 58.4635 22.4831 58.4635C23.1652 58.4635 23.8358 58.2883 24.4312 57.9556C25.0265 57.6228 25.5267 57.1434 25.8841 56.5625H28.0561",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInovation);
export default __webpack_public_path__ + "static/media/inovation.e543f7ed.svg";
export { ForwardRef as ReactComponent };